import { getInitialState, getPath } from "../../utils";
import primeState from "./InitialStates/DriverAssets";

const initialState = { ...primeState };

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVER_ASSETS_ISSUED_LIST":
      return setDriverTagsIssuedList(state, action);
    case "SET_ACTIVE_FILTERS_DRIVER_ASSETS":
      return setActiveFilters(state, action);
    case "RESET_STATE_DRIVER_ASSETS":
      return resetStateDriverAssets(state, action);
    case "RESET_STATES_DRIVER_ASSETS":
      return resetStatesDriverAssets(state, action);
    case "SET_DRIVER_CITIES":
      return setDriverCities(state, action);
    case "SET_ONBOARDING_CENTERS":
      return setOnboardingCenters(state, action);
    case "SET_DRIVER_ASSETS_AVAILABLE_LIST":
      return setDriverAssetsAvailableList(state, action);
    case "SET_RECENT_ASSET_STATUS":
      return setRecentAssetStatus(state, action);
    case "SET_PAYMENT_FLOW":
      return setPaymentFlow(state, action);
    default:
      return state;
  }
}

const setDriverCities = (state, action) => {
  return {
    ...state,
    cities: getPath(action.payload, "city", []),
  };
};

const setPaymentFlow = (state, action) => {
  return {
    ...state,
    paymentStatus: getPath(action.payload, "data", {}),
  };
};

const setOnboardingCenters = (state, action) => {
  console.log(state, action.payload);
  return {
    ...state,
    onboardingCenters: getPath(action.payload, "onboarding_centers", []),
  };
};

const setDriverAssetsAvailableList = (state, action) => {
  return {
    ...state,
    driverAssetsAvailableList: getPath(action.payload, "driver_assets", []),
  };
};

const setRecentAssetStatus = (state, action) => {
  return {
    ...state,
    recentAssetStatus: action.payload,
  };
};

const setDriverTagsIssuedList = (state, action) => {
  return {
    ...state,
    driverAssetsIssuedList: getPath(action.payload, "data", []),
  };
};

const resetStateDriverAssets = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const resetStatesDriverAssets = (state, action) => {
  const newStates = action.payload.state.reduce((acc, currkey) => {
    acc[currkey] = primeState[currkey];
    return acc;
  }, {});
  return {
    ...state,
    ...newStates,
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
